export const PRIZM_POLLING_TIME = 1000 / 15;
